import './ColorBox.scss';

export function ColorBox({ className = '', style = {}, children }) {
    return <div className={className + " ColorBox"} style={style}>
        {children}
    </div>
}